export const placeholders = {
  empty: '',
  default: 'Иванов Иван Иванович',
  name: 'Имя',
  patronymic: 'Отчество',
};

export function getPlaceholderText(queryArr: string[]) {
  if (!queryArr.filter(Boolean).length) {
    return placeholders.default;
  }

  if (queryArr.length === 1) {
    return placeholders.empty;
  }

  if (queryArr.length === 2 && !queryArr[1]) {
    return placeholders.name;
  }

  if (queryArr.length === 3 && !queryArr[2]) {
    return placeholders.patronymic;
  }

  return placeholders.empty;
}
